export default class Revendedor {
	constructor() {
		this.id =  null;
		this.nome =  '';
		this.email =  null;
		this.dataCadastro = null;
		this.ativo = false;
		this.cidade = {id: null};
		this.estado = {id: null};
		this.telefone = '';
		this.celular = '';
		this.cpf = '';
		this.clientes = [];
	}    
}